// react-table v7 verwijst naar de globale `regeneratorRuntime` (oude Babel
// async-transform). CRA/webpack leverde die global impliciet; Vite/esbuild niet.
// Deze side-effect import zet de global en houdt zoek-tabellen werkend.
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

Sentry.init({
    dsn: '',
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
